module.exports = __webpack_public_path__ + "static/img/nodata.1f506af3.png";